import { WALLET } from '../action/_ActionTypes';

const initialState = {
    balance:0,
    loading:true,
    type:'',
    error:''
};

export const reducer = (state = initialState, action) => {
    switch (action.type) {
        case WALLET.LOADING:
            return {
                ...state,
                loading: true
            };
        case WALLET.FETCH_SUCCESS:
            return {
                ...state,
                loading: false,
                balance: action.data.wallet.balance,
                type: action.data.wallet.type
            };
        case WALLET.FETCH_FAILED:
            return {
                ...state,
                loading: false,
                error: action.error
            };
        default:
            return state;
    }
};